import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { MatDialogModule, MatButtonModule } from '@angular/material';

@NgModule({
	declarations: [ConfirmDialogComponent],
	imports: [CommonModule, MatDialogModule, MatButtonModule],
	exports: [ConfirmDialogComponent],
	entryComponents: [ConfirmDialogComponent]
})
export class ConfirmDialogModule {}
